import { render, staticRenderFns } from "./vipDetailRefundGroupOrders.vue?vue&type=template&id=2a36279b&scoped=true"
import script from "./vipDetailRefundGroupOrders.vue?vue&type=script&lang=js"
export * from "./vipDetailRefundGroupOrders.vue?vue&type=script&lang=js"
import style0 from "./vipDetailRefundGroupOrders.vue?vue&type=style&index=0&id=2a36279b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a36279b",
  null
  
)

export default component.exports